<template>
      <el-cascader
          placeholder="搜索"
          size="mini"
          :options="publisherOptions"
          :value="noticeReceiver"
          collapse-tags
          :props="{ multiple: true }"
          filterable
          style="width: 358px"
          ref="cascader"
          clearable
          @change="change"
        >
      </el-cascader>
</template>

<script>
import {
getVipSelectApi,
} from "@/api/serviceRecord.js"
export default {
  name: 'publisher',
  props: {
    noticeReceiver: {
      type: Array
    }
  },
   data() {
    return {
      publisherOptions:[],
    };
  },
  methods: {
     change(value) {
        this.$emit("input", value);
    },
    dataHandle(){
      getVipSelectApi().then( response =>{
          let data = [
            {
              label: "杭州",
              value: "杭州",
              children: [
                {
                    label: "普通客服",
                    value: "普通客服",
                    children:[

                    ]
                },
                {
                    label: "VIP",
                    value: "VIP",
                    children:[
                      {
                        label: "VIP1组",
                        value: "VIP1组",
                        children:[

                        ]
                      },
                      {
                        label: "VIP2组",
                        value: "VIP2组",
                        children:[

                        ]
                      },
                      {
                        label: "VIP3组",
                        value: "VIP3组",
                        children:[

                        ]
                      },
                      {
                        label: "VIP4组",
                        value: "VIP4组",
                        children:[

                        ]
                      }
                    ]
                }
              ] 
            },
            {
                label: "山东",
                value: "山东",
                children: [
                  {
                      label: "普通客服",
                      value: "普通客服",
                      children:[
                      ]
                  },
                  {
                      label: "VIP",
                      value: "VIP",
                      children:[
                        {
                          label: "VIP1组",
                          value: "VIP1组",
                          children:[

                          ]
                        },
                        {
                          label: "VIP2组",
                          value: "VIP2组",
                          children:[

                          ]
                        },
                        {
                          label: "VIP3组",
                          value: "VIP3组",
                          children:[

                          ]
                        },
                      ]
                  }
                ] 
            },
            {
                label: "新疆",
                value: "新疆",
                children: [
                  {
                      label: "普通客服",
                      value: "普通客服",
                      children:[
                      ]
                  },
                  {
                      label: "VIP",
                      value: "VIP",
                      children:[
                        {
                          label: "VIP1组",
                          value: "VIP1组",
                          children:[

                          ]
                        },
                      ]
                  }
                ] 
            }
          ]
        for(let item of response.data.data.hangzhou.normal){
          let m = {
            label: "",
            value: "",
          }
          m.label = item.name;
          m.value = item.id;
          data[0].children[0].children.push(m);
        }
        // 杭州
        // vip1
        if(response.data.data.hangzhou.vip.vip_type_1 !=""){
            for(let item of response.data.data.hangzhou.vip.vip_type_1){
            let m = {
              label: "",
              value: "",
            }
            m.label = item.name;
            m.value = item.id;
            data[0].children[1].children[0].children.push(m);
          }
        }
        // vip2
        if(response.data.data.hangzhou.vip.vip_type_2 !=""){
            for(let item of response.data.data.hangzhou.vip.vip_type_2){
            let m = {
              label: "",
              value: "",
            }
            m.label = item.name;
            m.value = item.id;
            data[0].children[1].children[1].children.push(m);
          }
        }

        // vip3
        if(response.data.data.hangzhou.vip.vip_type_3 !=""){
            for(let item of response.data.data.hangzhou.vip.vip_type_3){
            let m = {
              label: "",
              value: "",
            }
            m.label = item.name;
            m.value = item.id;
            data[0].children[1].children[2].children.push(m);
          }
        }

        // vip4
        if(response.data.data.hangzhou.vip.vip_type_4 !=""){
            for(let item of response.data.data.hangzhou.vip.vip_type_4){
            let m = {
              label: "",
              value: "",
            }
            m.label = item.name;
            m.value = item.id;
            data[0].children[1].children[3].children.push(m);
          }
        }


        for(let item of response.data.data.shandong.normal){
          let m = {
            label: "",
            value: "",
          }
          m.label = item.name;
          m.value = item.id;
          data[1].children[0].children.push(m);
        }

        // 山东VIP
        // vip1
        if(response.data.data.shandong.vip.vip_type_1 !=""){
          for(let item of response.data.data.shandong.vip.vip_type_1){
            let m = {
              label: "",
              value: "",
            }
            m.label = item.name;
            m.value = item.id;
            data[1].children[1].children[0].children.push(m);
          }
        }

        // vip2
        if(response.data.data.shandong.vip.vip_type_2 !=""){
          for(let item of response.data.data.shandong.vip.vip_type_2 ){
            let m = {
              label: "",
              value: "",
            }
            m.label = item.name;
            m.value = item.id;
            data[1].children[1].children[1].children.push(m);
          }
        }

        // vip3
        if(response.data.data.shandong.vip.vip_type_3 !=""){
          for(let item of response.data.data.shandong.vip.vip_type_3 ){
            let m = {
              label: "",
              value: "",
            }
            m.label = item.name;
            m.value = item.id;
            data[1].children[1].children[2].children.push(m);
          }
        }


         // 新疆VIP
        // vip1
        if(response.data.data.xinjiang.vip.vip_type_1 !=""){
          for(let item of response.data.data.xinjiang.vip.vip_type_1){
            let m = {
              label: "",
              value: "",
            }
            m.label = item.name;
            m.value = item.id;
            data[2].children[1].children[0].children.push(m);
          }

        }

  
        for(let item of response.data.data.xinjiang.normal){
          let m = {
            label: "",
            value: "",
          }
          m.label = item.name;
          m.value = item.id;
          data[2].children[0].children.push(m);
        }





        this.publisherOptions = data;
        console.log("通知人",this.publisherOptions)
        })
        .catch(error =>{})
    },
  },
  mounted(){
      this.dataHandle();
  }
}

</script>